module.exports = __webpack_public_path__ + "static/media/beu_logo.06bd4a19.svg";